import styled from "styled-components";

export const Container = styled.div`
    top: -10px;
    z-index: 10;
    display: flex;
    flex-direction: column;

    /* padding: 16px 24px; */
    margin-top: 16px;
    margin-right: 24px;
    align-items: center;

    position: absolute;
    right: 0;
    border-radius: 10px;
    z-index: 9;

    @media print {
        display: none !important;
    }
`;

export const SubModulesNavHeader = styled.nav`
    display: flex;
    gap: 4px;
    width: 100%;
    justify-content: flex-start;
`;

export const Button = styled.button<{ active?: boolean }>`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
    white-space: nowrap;
    flex: 1;
    justify-content: center;

    background: ${({ active }) => active ? "#12619C" : "#f8f9fa"};
    color: ${({ active }) => active ? "#fff" : "#666"};

    span {
        color: ${({ active }) => active ? "#fff" : "#666"};
    }

`;

export const FloatingIndicators = styled.div`
    position: absolute;
    top: 60px;
    left: 45%;
    transform: translateX(-50%);
    z-index: 100;
    display: flex;
    gap: 4px;
`;

export const CxBoxRelaship = styled.div`
    background: white;
    border-radius: 8px;
    padding: 7px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const IndicatorIcon = styled.div<{ color?: string, backgroundColor?: string }>`
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;

    background-color: ${({ backgroundColor }) => backgroundColor || "#dcfce7"};
    svg {
        color: ${({ color }) => color || "#16a34a"};
    }
`;

export const IndicatorContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
`;

export const IndicatorValue = styled.div`
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    line-height: 1;
    flex-shrink: 0;
`;

export const IndicatorLabel = styled.div`
    font-size: 11px;
    color: #64748b;
    line-height: 1;
    white-space: nowrap;
`;

export const ShowInfoRelatorio = styled.div`
    position: absolute;
    top: 75px;
    right: 0;
    z-index: 100;
    cursor: pointer;
`;